import styled, { css } from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const Margin = styled.div<{ newDesign: boolean }>`
  ${({ newDesign }) =>
    newDesign &&
    css`
      margin-bottom: -2rem;
      @media (min-width: ${breakpoints.lg}) {
        margin-top: -1rem;
        margin-bottom: 4rem;
      }
    `}
`;
